module.exports = __webpack_public_path__ + "static/img/biaoge_image.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/biaoge_image.png
// module id = 162
// module chunks = 0